import { Checkbox, Label, Layout, Textbox} from "@mcleod/components";

export abstract class AutogenLayoutOrderTermsConditions extends Layout {
	checkboxAgree: Checkbox;
	lableTermsTitle: Label;
	textboxTerms: Textbox;
}
